import Image from "next/image"

export const NoFiltro = () => {
    return (
        <div className="flex justify-center items-center h-full">
            <div className="rounded-lg p-8">
                <div className="flex justify-center">
                    <div>
                        <Image
                            src="/img/ErrorFiltro.webp"
                            alt="NoData - Albert Einstein"
                            width={500}
                            height={500}
                            className="rounded-full"
                        />
                    </div>
                </div>
                <p className="text-lg font-semibold text-gray-800 text-center mt-4">
                    No hay datos filtros aplicados.
                </p>
                <p className="text-center mt-2 text-gray-600">
                   Debe aplicar filtros para ver la informacion
                </p>
            </div>
        </div>
    )
}
